import { render } from "./PortfolioSection.vue?vue&type=template&id=254af73a&scoped=true"
import script from "./PortfolioSection.vue?vue&type=script&lang=js"
export * from "./PortfolioSection.vue?vue&type=script&lang=js"

import "./PortfolioSection.vue?vue&type=style&index=0&id=254af73a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254af73a"]])

export default __exports__